/**
 * 验证手机号
 */
import React, { useEffect, useState } from 'react';
import styles from './phoneNumber.module.scss';
import { InputItem, Button, Toast } from 'antd-mobile';
import { ApiCore } from '../../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import { BASE_URL } from '../../../config/config';
import TitleComponent from '../comm/title/title';
import SubmitComponent from '../submit/submit';
import methods from '../../../utils/methods';
const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

const colorRed = { color: 'red' }
const colorBlack = { color: '#000' }
const colorGreen = { color: 'green' }

let clears:any = null;

function PhoneNumberComponent(props: any) {

    //手机号
    const [phone, setPhone] = useState<any>(null);
    //验证码
    const [codes, setCodes] = useState<any>('');
    //设置验证码颜色
    const [isRed, setColor] = useState<any>(colorBlack);
    //设置验证码文本
    const [showCode, setShowCode] = useState<boolean>(true);
    const [codeTxt, setcodeTxt] = useState<any>('获取验证码');
    //验证码倒计时
    const [countDownSecond, setCountDownSecond] = useState<any>(60);

    // 输入图形验证码
    const [graphCodes, setGraphCodes] = useState<any>(null);
    // 图形验证码url
    const [graphUrl, setGraphUrl] = useState<any>('');
    // 图形验证码是否验证通过
    const [isVerify, setVerify] = useState<any>(false);
    
    // 是否发送验证码
    const [isSendCode, setIsSendCode] = useState<any>(false);
    const [checked, setChecked] = useState<any>(null);
    const [appCode, setAppCode] = useState<any>(null);

    // 是否显示验证码
    const [isGraphUrl, setIsGraphUrl] = useState<any>(false);

    useEffect(() => {
        //设置网页title
        document.title = '报名';
        
        if (props.location.params) {
            setChecked(props.location.params.checked)
        }

        let appCode = sessionStorage.getItem('appCode')
        setAppCode(appCode)

        // 回显填写的值
        let cEchoData:any = {}
        let echoData = sessionStorage.getItem('echoData')
        if (echoData) {
            cEchoData = JSON.parse(echoData)
            setPhone(cEchoData.phone)
            setCodes(cEchoData.codes)
            setGraphCodes(cEchoData.graphCodes)
            setGraphUrl(cEchoData.graphUrl)
            setIsGraphUrl(true)
        }

    }, [])

    //获取图片验证码 
    const getImgCode = (value: any) => {
        let params = {
            phone: value?methods.trim(value, 'g'):''
        }
        api.GetImageCode(params).then(res => {
            if (res.code == '0') {
                setGraphUrl(res.data)
                setIsGraphUrl(true)
            }
        })
    }

    //输入图形验证码
    const onGraphCode = (value: any) => {
        setGraphCodes(value)
    }
    // 重新获取图形验证码
    const sendGraphCode = (value: any) => {
        getImgCode(phone)
    }

    //60s验证码倒计时
    const handleCountDown = (seconds = 60) => {
        let second = seconds;
        const countDown = () => {
            if (second > 0) {
                second--;
                setCountDownSecond(second);
            }
            if (second === 0) {
                second = 60;
                setCountDownSecond(second);
                setShowCode(true);
                setIsSendCode(false);
                setcodeTxt('重新获取');
                return;
            }
            clears = setTimeout(countDown, 1000);
        };
        clears = setTimeout(countDown, 1000);
    };

    // 获取手机号
    const onPhoneNumber = (value: any) => {
        setPhone(value)
        if (value.length == 13 && value != phone) {
            getImgCode(value)
        }
        
        setGraphCodes('')
        setCodes('')

        setShowCode(true);
        setcodeTxt('获取验证码');
        setVerify(false)
        setIsSendCode(false);

        clearTimeout(clears)
    }
    // 发送验证码
    const sendCode = (value: any) => {

        if (!phone || phone === '') {
            Toast.fail('请输入手机号')
        }
        else if (phone.length < 13) {
            Toast.fail('请正确输入手机号！')
        }
        else if (graphCodes === '') {
            Toast.fail('请输入图形验证码')
        }
        else {
            let params = {
                appCode,
                imageCode: graphCodes,
                phone: phone ? methods.trim(phone, 'g') : ''
            }

            api.GetVerificationCode(params).then(res => {
                if (res.code == '0') {
                    Toast.success('验证码发送成功！')

                    setIsSendCode(true);
                    setShowCode(false);
                    handleCountDown(60);
                    setVerify(true)
                }
                else {
                    Toast.fail(res.message)
                    setGraphCodes(null)
                    setVerify(false)
                    getImgCode(phone)
                }
            })
        }

    }
    //获取验证码
    const onCode = (value: any) => {
        setCodes(value);
        setColor(colorBlack);
    }

    // 使用账号密码绑定
    const changeBindWay = () => {
        sessionStorage.removeItem('echoData')
        props.history.push(`/findList/passWord/passWord`)
    }
    
    return (
        <div className={'content_wrap'}>
            <div className={styles.setPhone_content}>

                <TitleComponent title={'请输入您要关联的手机号'} subTitle={'根据手机号将为您绑定对应平台账号'} />

                <div className={styles.form_content}>
                    <div className={styles.phonoNumber_login}>
                        <div className={`${styles.InputItemContent} ${styles.phoneWrap}`}>
                            <label className={'findlabel'}>手机号</label>
                            <InputItem
                                value={phone}
                                type="phone"
                                placeholder="请输入手机号"
                                onChange={onPhoneNumber}
                                clear
                            >+86</InputItem>
                        </div>

                        <div className={`${styles.InputItemContent}`}>
                            <label className={'findlabel'}>图形验证码</label>
                            <span className={`${styles.graphWrap}`}>
                                <InputItem
                                    disabled={!phone}
                                    value={!phone ? '' : graphCodes}
                                    placeholder="请输入图形验证码"
                                    type='text'
                                    maxLength={5}
                                    onChange={onGraphCode}
                                    extra={
                                        <span
                                            hidden={!isVerify}
                                            className={isVerify ? `${colorGreen}` : `${colorRed}`}
                                        >
                                            {isVerify ? `验证通过 ` : `验证失败 `}
                                        </span>
                                    }
                                ></InputItem>
                                <div className={`${styles.graph}`} hidden={!isGraphUrl}>
                                    <img
                                        src={graphUrl}
                                        alt=''
                                        onClick={sendGraphCode}
                                    />
                                </div>
                            </span>
                        </div>

                        <div className={`${styles.InputItemContent} ${styles.smsWrap}`}>
                            <label className={'findlabel'}>手机验证码</label>
                            <InputItem
                                disabled={!graphCodes}
                                value={codes}
                                placeholder="请输入短信验证码"
                                type='number'
                                maxLength={6}
                                extra={
                                    showCode ?
                                        <Button disabled={!graphCodes} onClick={sendCode} type="primary">{codeTxt}</Button> :
                                        <Button disabled={true}>
                                            重新获取&nbsp;
                                            {`${countDownSecond}s`}
                                        </Button>
                                }
                                onChange={onCode}
                                style={isRed}
                            ></InputItem>
                        </div>

                        <div onClick={changeBindWay} className={'bindWay'}>使用账号密码绑定</div>
                    </div>
                </div>
            </div>
            
            <SubmitComponent
                text={'确认'} 
                type={'phonenumber'} 
                {...props}
                phone={phone}
                graphCodes={graphCodes}
                codes={codes}
                checked={props.location.params ? props.location.params.checked : checked}
                graphUrl={graphUrl}
            />

        </div>

    )
}

export default PhoneNumberComponent;